import { useState } from 'react';
import type { Case } from '../legalCasesType';

export const useCaseDetailsDrawer = () => {
    const [selectedCase, setSelectedCase] = useState<Case | null>(null);

    return {
        selectedCase,
        openCaseDrawer: (singleCase: Case) => setSelectedCase(singleCase),
        closeCaseDrawer: () => setSelectedCase(null),
    };
};
